module.exports = __webpack_public_path__ + "static/img/bg_earth_sky.27b00c10.jpg";